import { render, staticRenderFns } from "./TransactionPoints.vue?vue&type=template&id=32ccb731&scoped=true&"
import script from "./TransactionPoints.vue?vue&type=script&lang=js&"
export * from "./TransactionPoints.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPoints.vue?vue&type=style&index=0&id=32ccb731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ccb731",
  null
  
)

export default component.exports